/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {ChangeEvent, FocusEvent} from 'react'
import {
 FieldValues,
 FieldErrors,
 UseFormSetFocus,
} from 'react-hook-form'
import {KTText} from '../KTText'

interface Props {
 label?: string
 type: string
 required?: boolean
 id?: string
 name: string
 step?: string
 length?: number
 onChange?: (e: ChangeEvent<HTMLSelectElement>) => void
 onBlur?: (e: FocusEvent<HTMLSelectElement>) => void
 disabled?: boolean
 readonly?: boolean
 value?: string
 autoComplete?: string
 errorText?: string
 testId?: string
 className?: string
 containerClass?: string
 maxLength?: number
 minLength?: number
 min?: number
 max?: number
 wrapperClassName?: string
 labelClassName?: string
 helperTextClass?: string
 helperText?: string
 placeholder?: string
 autofocus?: boolean
 register?: any
 errors?: FieldErrors | undefined
 setFocus: UseFormSetFocus<FieldValues>
 validation?: FieldValues
}

const OTPField = ({
 label,
 className,
 wrapperClassName,
 containerClass,
 labelClassName,
 name,
 required,
 type,
 id,
 disabled = false,
 readonly = false,
 autoComplete = 'off',
 errorText,
 value,
 maxLength,
 minLength,
 min,
 max,
 autofocus,
 register,
 placeholder,
 helperTextClass,
 helperText,
 errors,
 length = 6,
 validation,
 setFocus,
}: Props) => {
 const handleChange = (input: string, index: number) => {
  if (input && index < length - 1) {
   setFocus(`${name}.${index + 1}`)
  }

  if (input.length === 0 && index > 0) {
   setFocus(`${name}.${index - 1}`)
  }
 }

 return (
  <div className={`${wrapperClassName}`}>
   {label && (
    <label
     htmlFor={id}
     className={`input-label ${labelClassName}`}
    >
     {label}
     {required && (
      <span className='required-field'> *</span>
     )}
    </label>
   )}
   <div
    className={`${containerClass} grid grid-cols-${length} gap-5`}
   >
    {Array.from({length}, (_, index) => (
     <input
      key={index}
      type={type}
      value={value}
      id={`${name}.${index}`}
      className={`form-input ${className} ${
       errors?.[`otp.${index}`] && 'border-[#CC293F]'
      }`}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readonly}
      autoComplete={autoComplete}
      autoFocus={autofocus}
      minLength={minLength}
      maxLength={maxLength}
      min={min}
      max={max}
      {...register(`${name}.${index}`, {
       ...validation,
       onChange: (e: {target: {value: string}}) =>
        handleChange(e.target.value, index),
      })}
     />
    ))}
   </div>
   {helperText && !errors?.[name] && (
    <KTText className={helperTextClass}>
     {helperText}
    </KTText>
   )}
   {errors?.[name] && (
    <p className='error-msg error-cls'>{errorText}</p>
   )}
  </div>
 )
}

export {OTPField}
